export default __webpack_public_path__ + "static/media/correct.4d93e2d2.mp3";